import LocationTypeModel from '../../models/Location/LocationTypeModel';
import BaseStore from '../BaseStore';

export default class LocationTypeStore extends BaseStore {
  constructor(transportLayer) {
    super(LocationTypeModel, transportLayer)
  }
};


// WEBPACK FOOTER //
// ./src/stores/Location/LocationTypeStore.js